export const promiseLandConstants = {
	PromiseLandSaveRequest: "PROMISELAND_SAVE_STARTED",
	PromiseLandSaveSuccess: "PROMISELAND_SAVE_COMPLETED",
	PromiseLandSaveFailure: "PROMISELAND_SAVE_FAILED",

	PromiseLand_GetByFilter_Request : "PROMISELAND_GET_ALL_STARTED",
	PromiseLand_GetByFilter_Success : "PROMISELAND_GET_ALL_COMPLETED",
	PromiseLand_GetByFilter_Failure: "PROMISELAND_GET_ALL_FAILED",

	PromiseLandDetailRequest: "PROMISELAND_GET_DETAIL_STARTED",
	PromiseLandDetailSuccess: "PROMISELAND_GET_DETAIL_COMPLETED",
	PromiseLandDetailFailure: "PROMISELAND_GET_DETAIL_FAILED",

	PromiseLandGetBooksRequest: "PROMISELAND_GET_BOOKS_STARTED",
	PromiseLandGetBooksSuccess: "PROMISELAND_GET_BOOKS_COMPLETED",
	PromiseLandGetBooksFailure: "PROMISELAND_GET_BOOKS_FAILED",

	PromiseLandDeleteRequest: "PROMISELAND_DELETE_STARTED",
	PromiseLandDeleteSuccess: "PROMISELAND_DELETE_COMPLETED",
	PromiseLandDeleteFailure: "PROMISELAND_DELETE_FAILED",
}